import {AccountFieldsPrefix, withPrefix} from '@/constants/prv-comp';
import {DocumentData} from '@/engine';
import {DetailedInvestorAccount} from '@/types/client-info';
import {COMP_TO_INVESTMENT_MAPPINGS} from './comp-to-investment-mappings';

export const detectRemovedInvestments = (
  storeData: DocumentData['data'],
  freshAccount: DetailedInvestorAccount,
  prefix: AccountFieldsPrefix,
): string[] => {
  const removedFundCodes = new Set<string>();

  COMP_TO_INVESTMENT_MAPPINGS.forEach(({compKeyField, getFreshInvestments, getKey}) => {
    const keyField = withPrefix(compKeyField, prefix);
    const freshKeys = new Set(getFreshInvestments(freshAccount.investments).map(getKey));
    const oldKeyPattern = new RegExp(`^${keyField}#\\d+$`);

    Object.entries(storeData).forEach(([key, value]) => {
      if (!oldKeyPattern.test(key) || typeof value !== 'string') return;

      if (!freshKeys.has(value)) {
        removedFundCodes.add(value);
      }
    });
  });

  return Array.from(removedFundCodes);
};
